import * as React from 'react';
import { useMaterialUIController } from 'context';
import MDBox from 'components/MDBox';
import styled, { css } from 'styled-components';
import MDTypography from 'components/MDTypography';
import { useState } from 'react';
import MDButton from 'components/MDButton';
import { Card, CircularProgress, Grid, Icon } from '@mui/material';
import MDInput from 'components/MDInput';
import { getAssetScore, updateAllocationTarget, updateAssetScore } from '../../api/allocationApi';
import { useEffect } from 'react';

function FormPontuarAtivo(props) {
    const [isLoading, setIsLoagding] = useState(false);
    const [metaPercentualAtivos, setMetaPercentualAtivos] = useState([{ asset: '', percentage: null }]);
    const [uptadingAtivo, setUpdatingAtivo] = useState('');
    const [uptadingPercentual, setUptadingPercentual] = useState('');
    const [openSnackMessage, setOpenSnackMessage] = useState(null);
    const [score, setScore] = useState(null);
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const { content, closeModal, isOpen, title, refreshGraph, currentData, openSnackBar, assetId, asstName } = props;
    const inputRef = React.useRef(null);

    useEffect(() => {
        //graph
        if (currentData?.length > 0) {
            setMetaPercentualAtivos(currentData.map(e => {
                return { asset: e.name, percentage: e.value }
            }))
        }

        loadInitialScore();

    }, []);

    const loadInitialScore = async () => {

        await getAssetScore(assetId)
            .then(e => {
                setScore(e.score);
                inputRef.current.focus()
            })
    }

    const handleSave = async () => {
        setIsLoagding(true);

        const body = {
            assetId: assetId,
            score: score
        };

        await updateAssetScore(body)
            .then((data) => {
                setIsLoagding(false);
                if (data?.errorCode) {
                    console.log(data)
                    openSnackBar({ type: 'error', message: `${data?.message}` });
                    return;
                }
                openSnackBar({ type: 'success', message: 'Peso estratégico do ativo atualizado com sucesso' });
                closeModal();
                props.refreshList();
            })
            .catch(e => {
                setIsLoagding(false);
                openSnackBar({ type: 'error', message: `${e}` });
            });
    };

    const handleAddPercentage = () => {
        setMetaPercentualAtivos((prev) => [...prev, { asset: '', percentage: null }]);
    };

    const handleDeletePercentage = (index) => {
        const updatedList = metaPercentualAtivos.filter((_, i) => i !== index);
        setMetaPercentualAtivos(updatedList);
    };

    const handleChangeAtivo = (index, value) => {
        const updatedList = metaPercentualAtivos.map((item, i) =>
            i === index ? { ...item, asset: value } : item
        );
        setMetaPercentualAtivos(updatedList);
    };

    const handleChangePercentage = (index, value) => {
        const updatedList = metaPercentualAtivos.map((item, i) =>
            i === index ? { ...item, percentage: value } : item
        );
        setMetaPercentualAtivos(updatedList);
    };

    const handleOpenSnackBar = (e) => {
        setOpenSnackMessage({ type: e?.type, message: e?.message });
    }

    return (
        <StyledContainer>
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <StyledMDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="dark">
                                    {title}
                                </MDTypography>
                            </StyledMDBox>
                            <MDBox pt={4} pb={3} px={3}>
                                <MDBox component="form" role="form">


                                    <StyledFormLine $isDarkMode={darkMode}>
                                        <MDBox mb={2} sx={{ width: '50%' }}>
                                            {asstName}
                                        </MDBox>
                                        <MDBox mb={2} sx={{ width: '30%' }}>
                                            <ForwardedMDInput
                                                ref={inputRef}
                                                type="number"
                                                label="Peso estratégico do ativo"
                                                fullWidth
                                                value={score}
                                                onChange={(e) => setScore(e.target.value)}
                                                error={score > 10}
                                                errorMessage={'A nota máxima permitida é 10'}
                                            />
                                        </MDBox>
                                    </StyledFormLine>

                                    <MDBox display="flex" alignItems="center" ml={-1}>

                                    </MDBox>
                                    <MDBox mt={4} mb={1}>
                                        <MDButton
                                            disabled={
                                                isLoading || 
                                                metaPercentualAtivos.reduce((total, item) => { return total + Number(item.percentage) }, 0) > 100 ||
                                                score > 10}
                                            variant="gradient" color={"success"} fullWidth onClick={handleSave}>
                                            {isLoading
                                                ? <CircularProgress color="inherit" size={16} />
                                                :
                                                'Salvar'
                                            }

                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
        </StyledContainer>
    );
}

export default FormPontuarAtivo;

const StyledButton = styled(MDButton)`
    border-radius: 550px !important;
    min-height: 10px !important;
    min-width: 10px !important;
    height: 40px !important;
    width: 40px !important;

    span:nth-child(1){
        font-size: 1.1rem !important;
        font-weight: 900;
    }
`;

const StyledFormLine = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;

    ${({$isDarkMode}) => css`
    div{
        color: ${$isDarkMode ? '#FFFFFFCC' : '#7B809A'};
    }

    `}

   
`;

const StyledMDBox = styled(MDBox)`
  background: radial-gradient(circle at 221% 201%, #f28371 0%, #f28371 65%, transparent 0%) ,#f0ba8d !important; 
`;

const StyledContainer = styled.div`
    width: 100%;

    [role="dialog"]{
        margin: 50px;
    }


    // @media screen and (max-width: 767px) {
    //     padding-top: 0px !important;
    //   }
`;

const StyledInput = styled(MDBox)`

// width: 50%;
[data-input] {
    & > div > div {
        // border: 1px solid red;
        height: 44px;
        
        & > input {
            padding: 0 5px !important;
        }
    }
}
`;

const ForwardedMDInput = React.forwardRef((props, ref) => (
    <MDInput {...props} inputRef={ref} />
));
